import { LinkId } from '../../../common/AnalyticsContext/LinkId';
import { useSearchFilters } from '../../../common/components/SearchHeader/filters/useSearchFilters';
import { FilterPill } from '../FilterPill/FilterPill';
import { useOverlay } from '../overlay/OverlayContext';

export const PricingFilter = () => {
  const [filters, setFilters] = useSearchFilters();
  const { clear } = useOverlay();

  const handleClick = () => {
    setFilters({
      ...filters,
      pricingAvailable: !filters.pricingAvailable,
    });

    clear();
  };

  return (
    <FilterPill
      trackingId={LinkId.FILTER_BY_PRICING_AVAILABLE_BUTTON}
      tooltip="Show practices with treatment pricing published on their profile."
      onClick={handleClick}
      hasValue={filters.pricingAvailable}
    >
      Pricing available
    </FilterPill>
  );
};
